import React from 'react';
import { Card } from '../lib/Card';
import { Link } from 'react-router-dom';

export default class ImpressumView extends React.Component<{}, {}> {
  render() {
    return <>
      <Card headerText={"Impressum"} >
        <p>Inhaber / Ansprechperson: Bernd Herzog (Einzelunternehmer)</p>
        <p>Post-Adresse: Sachsenplatz 15 / Top 6, 1200 Wien</p>

        { // TODO: <p>UID: xxxxxx k</p>
        }

        <p><Link to="/contact" onClick={(() => { document.getElementById("scrollDiv")?.scrollTo(0, 0); }).bind(this)} style={{ color: "#D00" }}>Kontakt</Link></p>
        <p>Kammerzugehörigkeit: Wirtschaftskammer Wien</p>
        <p>
          Haftungsausschluss:

          Die bereitgestellten Informationen auf dieser Web Site wurden sorgfältig geprüft und werden regelmäßig aktualisiert. Jedoch kann
          keine Garantie dafür übernommen werden, dass alle Angaben zu jeder Zeit vollständig, richtig und in letzter Aktualität dargestellt
          sind. Dies gilt insbesondere für alle Links zu anderen Websites, auf die direkt oder indirekt verwiesen wird. Alle Angaben können
          ohne vorherige Ankündigung ergänzt, entfernt oder geändert werden.
        </p>
      </Card>
    </>
  }
}
